import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { browserHistory } from 'react-router';
import * as Actions from '../models/feeds/actions';
import Sidebar from '../components/Sidebar';
import Store from '../library/M2Store';
import FeedMore from '../components/FeedMore';

class FeedControllerMore extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            dark_mode: (Store.get('m2darkmode') && Store.get('m2darkmode') == 'dark') ? true : false,
            item_id: props.params.id,
            feed_more: {},
            load: false
        };
    }

    __setDarkMode(event) {
        event.preventDefault();
        let dark_mode = !this.state.dark_mode;
        if(dark_mode) {
            Store.set('m2darkmode', 'dark');
        } else {
            Store.remove('m2darkmode');
        }
        this.setState({dark_mode: dark_mode});
    }

    addToBookmark(feed_id) {
        this.props.actions.addBookmark(feed_id);
    }


    hideMoreItem() {
        browserHistory.push('/feeds');
    }

    componentDidMount() {
        this.props.actions.loadFeedInfo(this.state.item_id);
    }

    componentWillReceiveProps(p) {
        if(p.answer && p.answer.state) {
            switch(p.answer.state) {
                case 'FINISH_ADD_BOOKMARK_FEED':
                    this.props.actions.loadFeedInfo(this.state.item_id);
                    break;

                case 'FINISH_LOAD_FEED':
                    if(p.answer.data.result == 'success') {
                        this.setState({
                            load: true,
                            feed_more: p.answer.data.data
                        });
                    } else {
                        browserHistory.push('/feeds');
                    }
                    break;
                case 'ERROR_LOAD_FEED':
                    browserHistory.push('/feeds');
                    break;
            }

        }
    }

    render() {
        let className = ['m2controller', 'm2controller__feed'];

        if(this.state.dark_mode) {
            className.push('m2dark_mode');
        }

        let svg_logo = '<use xlink:href="#icon-logo"></use>';

        return (
            <div className={className.join(' ')}>
                <div className="m2sidebar">
                    <Sidebar darkmode={this.__setDarkMode.bind(this)}/>
                </div>
                <div className="m2content">
                    <div className="m2content__header">
                        <div className="header__logo">
                            <svg width="145px" height="43px" dangerouslySetInnerHTML={{__html: svg_logo}}></svg>
                        </div>
                    </div>
                    <div className="m2content__container m2feeds_container">
                        <div className="m2content__feed_more visible">
                            {this.state.load && <FeedMore hideOpenWindow={true} addToBookmark={this.addToBookmark.bind(this)} hideMore={this.hideMoreItem.bind(this)} {...this.state.feed_more}/>}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}


const mapStateToProps = state => ({
    answer: state.FeedReducer
});
const mapDispatchProps = dispatch => ({
    actions: bindActionCreators(Actions, dispatch)
});

export default connect(
    mapStateToProps,
    mapDispatchProps
)(FeedControllerMore);



// WEBPACK FOOTER //
// ./src/controllers/FeedControllerMore.js